import { Component, Vue } from "vue-property-decorator";
import vuescroll from "vuescroll";
import CardItem from "./CardItem/CardItemComponent";
import MobileFacade from "@/facades/MobileFacade";
import ServiceDefaultName from "@/api/Services/ServiceDefaultName";
import { servicesImages } from "@/constants/images";
@Component({
  name: "CardsComponent",

  components: {
    CardItem,
  },
})
export default class CardsComponent extends Vue {
  cx_vueScroll?: vuescroll;

  cx_vueScrollOption = {
    vuescroll: {},
    scrollPanel: {
      initialScrollY: false,
      initialScrollX: "0%",
      scrollingX: true,
      scrollingY: false,
      speed: 300,
      easing: undefined,
      verticalNativeBarPos: "right",
    },
    rail: {
      gutterOfEnds: "19px",
    },
    bar: {
      background: "#C4C4C4",
    },
  };

  cx_isMobile = MobileFacade.isMobile();

  cx_cards: any = [];

  constructor() {
    super();
  }

  created(): void {
    this.cx_vueScroll = this.$refs["vs"] as vuescroll;
    this.getServicesValues();
  }

  getServicesValues(): void {
    ServiceDefaultName.getDisplayRule().then((response) => {
      const services = response.data.data;
      services.forEach((service: any) => {
        const code = service.code as number;
        const card: any = {
          title: service.search_name,
          image: servicesImages[code].image,
          value: service.avg_price,
          link: "resultados",
          code: code,
        };
        this.cx_cards.push(card);
      });
    });
  }
}
